import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { NgbCustomDateParserService } from 'src/app/formatters/ngb-custom-date-parser.service';
import { ServiceService } from 'src/app/services/service.service';
import { LoadDetailFilter } from './load-filter.model';

@Component({
  selector: 'app-load-details',
  templateUrl: './load-details.component.html',
  styleUrls: ['./load-details.component.css']
})
export class LoadDetailsComponent implements OnInit {

  public size: number = 100;
  public page: number = 0;
  public logon: any = "matte";
  public scac : any = "demo";
  public drsStartDate : any;
  public drsEndDate : any;
  users: any[] = [];

  loadDetailFilter: LoadDetailFilter = new LoadDetailFilter();

  hoveredDate: NgbDate;


  showOverlay = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ServiceService,
    public ngbCustomDateParserService: NgbCustomDateParserService,
    public formatter: NgbDateParserFormatter,
    private calendar: NgbCalendar,
    private ngModal: NgbModal,
    private datePipe: DatePipe,
  ) {

  this.loadDetailFilter.fromDate = calendar.getPrev(calendar.getToday(), 'd', 180);
  this.loadDetailFilter.toDate = calendar.getNext(calendar.getToday(), 'd', 0);

  }



  ngOnInit(): void {
  }

  submitMethod(){
      $(".overlay-loading").show();
     // this.loadDetailFilter.drsStartDate = this.loadDetailFilter.fromDate+"";
     // this.loadDetailFilter.drsEndDate = this.loadDetailFilter.toDate+"";
      this.loadDetailFilter.drsStartDate = new Date(this.loadDetailFilter.fromDate.year, this.loadDetailFilter.fromDate.month - 1, this.loadDetailFilter.fromDate.day) + "";
      this.loadDetailFilter.drsEndDate = new Date(this.loadDetailFilter.toDate.year, this.loadDetailFilter.toDate.month - 1, this.loadDetailFilter.toDate.day) + "";
      this.loadDetailFilter.drsStartDate = this.datePipe.transform(this.loadDetailFilter.drsStartDate, 'yyyy-MM-dd');
      this.loadDetailFilter.drsEndDate = this.datePipe.transform(this.loadDetailFilter.drsEndDate, 'yyyy-MM-dd');
      this.service.getLoadDetails(this.loadDetailFilter, this.page, this.size).subscribe(res => {
        $(".overlay-loading").hide();
        this.users = res;
      }, error => {
        $(".overlay-loading").hide();
        console.log(error);
      });
  }

  nextBtnClick(incr) {
    this.page = +this.page + incr;
    this.submitMethod();
  }

  formatDateForDisplay(date) {
    return this.ngbCustomDateParserService.format(date);
  }

  closeDatePicker = false;
  onDateSelection(date: NgbDate) {
    this.closeDatePicker = false;
    if (!this.loadDetailFilter.fromDate && !this.loadDetailFilter.toDate) {
      this.loadDetailFilter.fromDate = date;
    } else if (this.loadDetailFilter.fromDate && !this.loadDetailFilter.toDate && date.after(this.loadDetailFilter.fromDate)) {
      this.loadDetailFilter.toDate = date;
      this.closeDatePicker = true;
      this.showOverlay = false;
    } else {
      this.loadDetailFilter.toDate = null;
      this.loadDetailFilter.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.loadDetailFilter.fromDate && !this.loadDetailFilter.toDate && this.hoveredDate && date.after(this.loadDetailFilter.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.loadDetailFilter.fromDate) && date.before(this.loadDetailFilter.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.loadDetailFilter.fromDate) || date.equals(this.loadDetailFilter.toDate) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate, input: string): NgbDate {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  public redirectToEditScreen(selectedLoad?: any): void {
    localStorage.setItem('selectedLoad', JSON.stringify(selectedLoad));
    this.router.navigate(['load-details/add-edit/loadDetails/true'], {state: {load:selectedLoad}});
  }

}
